<template>
  <div class="rtl">
    <m-form
      :title="title"
      :items="items"
      :cols="cols"
      :canSubmit="canSubmit"
      :canDelete="canDelete"
      list-export-base-url="reports/lists/floatAccounts"
      :list_filters="{}"
      :exportParams="{id: item.id}"
      :is-editing.sync="isEditing"
      :showListBtn="false"
      :show-clear-btn="false"
      :show-navigation-btns="false"
      @click:row="setItem"
      @clearForm="clearForm"
      @submit="submit"
      @delete="deleteItem"
    >
      <template #header-btns>
        <v-btn depressed class="secondary rounded-lg white--text mr-1 mt-1 mt-md-0" :to="`/panel/floatAccountGroups`"
        >  گروه حساب شناور</v-btn>
        <v-btn  depressed class="primary rounded-lg white--text mr-1 mt-1 mt-md-0"  @click="clearForm"
        > حساب شناور </v-btn>
      </template>

      <v-row>
        <v-col cols="12">
          <v-text-field class="rounded-lg" label=" * نام" v-model="item.name" :disabled="!isEditing" />
        </v-col>
        <v-col cols="12">
          <v-textarea class="rounded-lg" label="توضیحات" v-model="item.explanation" :disabled="!isEditing" />
        </v-col>
        <v-col cols="12">
          <v-autocomplete
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg"
              label= "* گروه حساب شناور"
              :items="floatAccountGroups"
              v-model="item.floatAccountGroups"
              item-text="name"
              :disabled="!isEditing"
              multiple
              :return-object="true"
              deletable-chips
              small-chips
          />
        </v-col>
      </v-row>
    </m-form>
  </div>
</template>
<script>
import AccountApiMixin from "@/mixin/accountMixin";
import { MFormMixin } from "@/components/m-form";

export default {
  mixins: [MFormMixin, AccountApiMixin],
  props: {
    is_cost_center: {
      default: false,
    },
  },
  data() {
    return {
      baseUrl: "accounts/floatAccounts",
      permissionBasename: "floatAccount",
      cols: [
        {
          text: "نام حساب شناور",
          value: "name",
          type: "text",
          filters: ["name"],
        },
        {
          text: "توضیحات",
          value: "explanation",
          type: "text",
          filters: ["expalantion"],
        },
      ],
    };
  },
  computed: {
    title() {
      return "تعریف حساب های شناور > حساب شناور";
    },
    items() {
      return this.floatAccounts;
    },
  },
  methods: {
    getData() {
      this.getFloatAccounts(true);
      this.getFloatAccountGroups(true);
    },
    getSerialized() {
      let data = this.copy(this.item);
      data = this.extractIds(data);
      data.syncFloatAccountGroups = [];
      if (data.floatAccountGroups) {
        for (const fag of data.floatAccountGroups) {
          data.syncFloatAccountGroups.push(fag.id);
        }
        return data;
      }
      else{
        return data;
      }
    
    },
  },
};
</script>
